export default {"src":"/_next/static/media/step2g.f4fd28c5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};